require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-redux-combine-multiple-reducers.json") })
        }
      }, "path---front-end-libraries-redux-combine-multiple-reducers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-redux-combine-multiple-reducers!./.cache/json/front-end-libraries-redux-combine-multiple-reducers.json
// module id = 2112
// module chunks = 231608221292675